import { render } from "./NewImage.vue?vue&type=template&id=56f46604"
import script from "./NewImage.vue?vue&type=script&lang=js"
export * from "./NewImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__